import axios, { AxiosResponse } from "axios";
import { announcementApis } from "../../../common/apis";

export const getAnnouncement = (announcementPath: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.get(announcementPath).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      err => {
        reject(err);
      },
    );
  });
};

export const agreeAnnouncement = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.post(announcementApis.agreeAnnouncement).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      err => {
        reject(err);
      },
    );
  });
};